import { buildEndpointUrl } from '@/_shared/helpers/makeSwaggerToEndpointUrl';
import {
  API_ORGANIZATIONS_ORGANIZATIONID_QUIZZES_COMPLETIONS_PATH_KEY,
  API_ORGANIZATIONS_ORGANIZATIONID_QUIZZES_COMPLETIONS_ID_NEXT_PATH_KEY,
  API_ORGANIZATIONS_ORGANIZATIONID_QUIZZES_COMPLETIONS_ID_RESULT_PATH_KEY,
  API_ORGANIZATIONS_ORGANIZATIONID_QUIZZES_TEMPLATES_TEMPLATEID_PATH_KEY,
} from '@/swagger/constants/quiz-keys';

export const API_POST_QUIZ_START = (org: string) => {
  return buildEndpointUrl(API_ORGANIZATIONS_ORGANIZATIONID_QUIZZES_COMPLETIONS_PATH_KEY, {
    organizationId: org,
  });
};

export const API_POST_QUIZ_BY_ID_NEXT = (org: string, quizId: string) => {
  return buildEndpointUrl(API_ORGANIZATIONS_ORGANIZATIONID_QUIZZES_COMPLETIONS_ID_NEXT_PATH_KEY, {
    organizationId: org,
    id: quizId,
  });
};

export const API_GET_QUIZ_BY_ID_RESULT = (org: string, quizId: string) => {
  return buildEndpointUrl(API_ORGANIZATIONS_ORGANIZATIONID_QUIZZES_COMPLETIONS_ID_RESULT_PATH_KEY, {
    organizationId: org,
    id: quizId,
  });
};

export const API_GET_QUIZ_BY_ID = (org: string, templateId: string) => {
  return buildEndpointUrl(API_ORGANIZATIONS_ORGANIZATIONID_QUIZZES_TEMPLATES_TEMPLATEID_PATH_KEY, {
    organizationId: org,
    templateId,
  });
};
